module.exports = __webpack_public_path__ + "static/00004.3895406c.jpg";